<template>
  <div id="">
    <div >
      <div class="pt-5" id="presession"></div>
      <div class="boxArea ">
        <v-row>
          <v-col cols="12" lg="6" class="">
            <div v-if="isRoobrooTimezone" class="d-flex justify-center flex-column fill-height">
              <div class="titleBox">
                تست، تشخیص نیست.
              </div>
              <div class="descBox">
                این نتیجه می‌تواند شروعی برای شناخت بهتر خودت باشد؛ اگر خواستی، ادامه مسیر را با یک درمانگر طی کن.
              </div>
              <div class="d-flex">
                <a href="https://roobroo.ir/simiaroom">
                  <div class="actionBtn">
                    ادامه مسیر
                    <img src="../../assets/tests/presession-arrow.png">
                  </div>
                </a>
              </div>
            </div>
            <div v-else-if="!isLoggedIn">
              <v-fade-transition mode="out-in">
                <div :key="1" v-if="state == 'get-data'">
                  <div class="formBox">
                    <div class="titleBox">
              <span style="color:#30A778;">
                مسیر تراپی‌ات
              </span>
                      از همین‌جا شـــروع میشه
                    </div>
                    <div class="descBox">
                      با یک گفت‌وگوی کوتاه، در کنارتیم تا درمانگری رو پیدا کنی،
                      <br>
                      که واقعاً با تو و نیاز‌هات هم‌راستا باشه.
                    </div>
                    <v-form ref="form" @submit.prevent="submitData" @keypress.native.enter="submitData">
                      <div class="timezoneInputWrapper">
                        <v-text-field

                            :class="$vuetify.breakpoint.lg && !$vuetify.rtl  ? 'rightMarginLtr' : ''"
                            class="timezoneInput body-small-14-regular  "
                            label="ایمیل"
                            v-model="email"
                            item-text="name"
                            style="direction: ltr"
                            :rules="requiredRules"
                            item-value="value"
                            outlined
                        >
                        </v-text-field>
                        <v-text-field
                            style="direction: ltr"
                            :class="$vuetify.breakpoint.lg && !$vuetify.rtl  ? 'rightMarginLtr' : ''"
                            class="timezoneInput body-small-14-regular  "
                            label="شماره واتساپ / تلگرام"
                            v-model="phone"
                            item-text="name"
                            :rules="phoneRules"
                            item-value="value"
                            outlined
                        >
                        </v-text-field>
                      </div>
                    </v-form>
                    <div class="actionBtn" @click="submitData">
                      رزرو جلسه ارزیابی
                      <img src="../../assets/tests/presession-arrow.png">
                    </div>
                  </div>
                </div>
                <div :key="2" v-else class="d-flex flex-column justify-center fill-height">
                  <div class="text-center">
                    <v-btn fab elevation="0" class="green--text" x-large color="rgba(0, 128, 0,.2)">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <div class="titleBox">
                      اطلاعات شما ثبت شد
                    </div>
                    <div class="descBox">
                      به دلیل درخواست‌های زیاد، برای تسریع در هماهنگی و برگزاری جلسه پیش‌مشاوره، می‌توانید همزمان جلسه
                      مشاوره
                      اصلی خود را رزرو کنید. این کار باعث می‌شود که فرآیند درمان شما سریع‌تر آغاز شود.
                    </div>
                  </div>
                </div>
              </v-fade-transition>
            </div>
            <div v-else class="d-flex justify-center flex-column fill-height">
              <div class="titleBox">
                برای انتخاب تراپیست به کمک احتیاج داری؟
              </div>
              <div class="descBox">
                می‌تونی یه جلسه ارزیابی رایگان داشته باشی تا با هم بررسی کنیم کدوم تراپیست برات مناسب‌تره. یه گفت‌و‌گوی
                ساده، یه قدم مطمئن.
              </div>
              <div class="d-flex">
                <router-link :to="{name:'newPresession'}">
                  <div class="actionBtn">
                    رزرو رایگان جلسه
                    <img src="../../assets/tests/presession-arrow.png">
                  </div>
                </router-link>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" class="text-center vectorPreSession" v-if="$vuetify.breakpoint.mdAndUp">
            <img src="../../assets/tests/vector_presession.svg" alt="">
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixins from "@/mixins/AuthMixins";
import {mapGetters} from "vuex";

export default {
  mixins: [AuthMixins],
  data() {
    return {
      state: 'get-data',
      phone: null,
      email: null,
      userToken: null,
      isFromIran: true,
      timezone: null,
    }
  },

  computed: {
    ...mapGetters({
      'isLoggedIn': 'getIsLoggedIn'
    }),
    isRoobrooTimezone() {
      return this.timezone === 'Asia/Tehran' || this.timezone === 'Asia/Kabul'
    }
  },
  methods: {
    submitData() {
      if (this.$refs.form.validate()) {
        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'preSessionRegister', {}, {
          email: this.email,
          mobile: this.phone.replaceAll(" ", ""),
          from: "new_journey_presession",
          timezone: this.getDefaultTimezone(),
        }).then((resp) => {
          this.userToken = resp.data.token;
          this.state = "success";
          if (!this.isFromIran) {
            location.href = `https://app.simiaroom.com/fa/login-with-token?callback=newPresession&token=${resp.data.token}`;
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    getDefaultTimezone() {
      try {
        let options = {timeZoneName: "long"};
        return Intl.DateTimeFormat(undefined, options).resolvedOptions()
            .timeZone;
      } catch (er) {
        console.log(er);
      }
    },
  },
  mounted() {
    this.isFromIran = this.getDefaultTimezone() == "Asia/Tehran";
    this.timezone = this.getDefaultTimezone();
    // this.pushAlert("لطفا ایمیل خود را به درستی وارد کنید.");
  },

}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 1000px) {
  .formBox {
    border: none !important;
  }

  .boxArea {
    margin-top: 20px !important;
  }

}

@media (min-width: 1000px) and (max-width: 1500px) {
  .vectorPreSession img {
    margin-top: 0px !important;
  }
}

.actionBtn:hover {
  opacity: 0.8;
  transition: all 0.3s
}

.actionBtn {
  cursor: pointer;
  color: white;
  margin-top: 24px;
  display: flex;
  width: 192px;
  height: 48px;
  padding: 0 19.55px 0 15.55px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #39C990;
  transition: all 0.3s
}

.boxArea {
  position: relative;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 24px;
  padding: 30px;
  margin-top: 100px;
}

.descBox {
  color: #212121;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.titleBox {
  color: #212121;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.formBox {
  border: 1px solid #DBE4ED;
  border-radius: 24px;
  padding: 24px;
}

.timezoneInputWrapper :deep(.v-input__slot) fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
  border-radius: 8px !important;
}

.timezoneInputWrapper :deep(.v-input__slot):hover fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-input--is-focused .v-input__slot) fieldset {
  border-color: #3cbe8b !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-text-field__details) {
  display: none !important;
}

.timezoneInput {
  margin-top: 16px;
  border-radius: 12px !important;
}

.timezoneInputWrapper :deep(.v-input__control),
.timezoneInputWrapper :deep(input),
.timezoneInputWrapper :deep(.v-label) {
  font-size: 14px;
  font-weight: 400;
  font-family: YekanBakh !important;
}

.vectorPreSession img {
  width: 70% !important;
  margin-top: -100px;
}
</style>